import { json } from '../core/data-source/json.mapper';

export class LanguageRecord {
    @json()
    code: string;
    @json() 
    name: string;
}